export const getVenderJoinedYears = (dateStr) => {
  if (!dateStr) return 0

  const joinedDate = new Date(dateStr)
  if (isNaN(joinedDate.getTime())) return 0

  const now = new Date()
  let years = now.getFullYear() - joinedDate.getFullYear()
  const monthDiff = now.getMonth() - joinedDate.getMonth()

  if (
    monthDiff < 0 ||
    (monthDiff === 0 && now.getDate() < joinedDate.getDate())
  ) {
    years--
  }

  return Math.max(0, years)
}
